import AiTrainingIndex from "@/views/aiTraining/index";

export default [
  {
    path: "/ai-training",
    name: "aiTraining",
    // 同步加载，避免从报名页跳入后再等异步分包
    component: AiTrainingIndex,
    meta: { title: "人工智能赋能职业教育教学关键要素改革的实践创新专题培训" }
  },
  {
    path: "/ai-training/preview",
    name: "aiTrainingPreview",
    component: () => import("@/views/aiTraining/preview"),
    meta: { title: "资源预览" }
  }
];



// WEBPACK FOOTER //
// ./src/router/aiTraining.js